/*
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-09-08 15:30:36
 * @LastEditors: loong
 * @LastEditTime: 2022-09-22 17:50:12
 */
// 通用顶部条组件
const topbar = () => import ("../../layout/topbar");
// 通用主体顶部组件
const AppHeader_main = () =>import ("../../layout/AppHeader_main");
// 当前路由组件
const ReleaseRequirements = () => import('../../views/ReleaseRequirements/index');
export default [{
  path: "/ReleaseRequirements",
  name: "ReleaseRequirements",
  components: {
    topbar: topbar,
    header:AppHeader_main,
    default: ReleaseRequirements
  },
  meta: {
    requireAuth: true // 需要验证登录状态
  },
  props: {
      header: {
         type:'2',//根据不同类型切入组件判断逻辑
      }
  },
}
]
